export const ptBR = {
  // Common/Generic
  "common.name": "Nome",
  "common.establishmentName": "Nome do estabelecimento",
  "common.email": "E-mail",
  "common.password": "Senha",
  "common.country": "País",
  "common.state": "Estado",
  "common.city": "Cidade",
  "common.all": "Todos",
  "common.active": "Ativo",
  "common.inactive": "Inativo",
  "common.createdAt": "Criado em",
  "common.yes": "Sim",
  "common.no": "Não",
  "common.add": "Adicionar",
  "common.edit": "Editar",
  "common.delete": "Excluir",
  "common.view": "Ver",
  "common.save": "Salvar",
  "common.saveNow": "Salvar agora",
  "common.cancel": "Cancelar",
  "common.confirm": "Confirmar",
  "common.undo": "Desfazer",
  "common.close": "Fechar",
  "common.create": "Criar",
  "common.update": "Atualizar",
  "common.search": "Pesquisar",
  "common.actions": "Ações",
  "common.status": "Situação",
  "common.success": "Sucesso",
  "common.error": "Erro",
  "common.loading": "Carregando",
  "common.back": "Voltar",
  "common.continue": "Continuar",
  "common.submit": "Enviar",
  "common.manage": "Gerenciar {name}",
  "common.export": "Exportar",
  "common.download": "Baixar",
  "common.title": "Título",
  "common.establishments": "Estabelecimentos",
  "common.establishmentsHelper":
    "Digite pelo menos 3 letras para procurar pelo estabelecimento",
  "establishmentAutocomplete.searchError":
    "Erro ao buscar estabelecimentos. Tente novamente.",
  "filters.title": "Filtros",
  "filters.onlyActive": "Somente ativas",
  "filters.sort.default": "Ordenar",
  "filters.sort.nameAsc": "Nome (A → Z)",
  "filters.sort.nameDesc": "Nome (Z → A)",
  "filters.sort.createdAsc": "Criado (Mais antigo)",
  "filters.sort.createdDesc": "Criado (Mais novo)",
  "cameras.confirmTitle": "Confirmar ação",
  "cameras.confirmMessage": "Tem certeza que deseja {name}?",
  "cameras.manageDescription": "logos, músicas, vídeos do site...",
  "cameras.openPreviewTooltip": "Abrir pré-visualização",

  // Common Messages
  "messages.saveSuccess": "Salvo com sucesso!",
  "messages.deleteSuccess": "Excluído com sucesso!",
  "messages.updateSuccess": "Atualizado com sucesso!",
  "messages.createSuccess": "Criado com sucesso!",
  "messages.loadError": "Erro ao carregar dados",
  "messages.saveError": "Erro ao salvar",
  "messages.deleteError": "Erro ao excluir",
  "messages.connectionError": "Houve um problema de conexão, tente novamente.",
  "messages.youtubeTokenExpired":
    "A conexão com o YouTube expirou. Renove a autorização da conta do YouTube no painel administrativo e tente novamente.",
  "global.generic_error": "Erro inesperado. Tente novamente.",
  "global.saved": "Salvo com sucesso.",
  "global.discarded": "Alterações descartadas.",
  "messages.serverError": "Erro interno do servidor, tente novamente.",
  "messages.unsavedChanges":
    "Você tem alterações não salvas. Deseja realmente sair sem salvar?",
  "messages.leaveWithoutSaving": "Sair sem salvar",
  "messages.stayOnPage": "Continuar editando",
  "errorBoundary.title": "Algo deu errado",
  "errorBoundary.body": "Ocorreu um erro inesperado ao carregar esta página. Tente novamente.",
  "errorBoundary.retry": "Tentar novamente",
  "messages.confirmDelete":
    "Esta ação é irreversível. Deseja continuar mesmo assim?",
  "messages.fillRequiredFields": "Preencha todos os campos obrigatórios",
  "global.cancel": "Cancelar",
  "global.close": "Fechar",
  "global.save": "Salvar",

  // Common Validations
  "validation.required": "{field} é obrigatório",
  "validation.emailRequired": "E-mail é obrigatório",
  "validation.passwordRequired": "Senha é obrigatória",
  "validation.invalidEmail": "E-mail inválido",
  "validation.passwordMismatch": "Senhas não coincidem",
  "validation.passwordCriteria":
    "A senha não atende aos critérios de segurança",

  // Common Placeholders
  "placeholder.enterEmail": "Digite seu e-mail",
  "placeholder.enterPassword": "Digite sua senha",
  "placeholder.search": "Pesquisar",
  "placeholder.searchByNameOrEmail": "Pesquisar por nome ou email",

  // Login
  "login.welcome": "Bem-vindo ao",
  "login.adminPanel": "Painel Administrativo",
  "login.subtitle": "Gerencie suas câmeras, transmissões e assinaturas",
  "login.enterPanel": 'Entrar no "Painel Administrativo"',
  "login.enterEmailPlaceholder": "Digite seu e-mail",
  "login.enterPasswordPlaceholder": "Digite sua senha",
  "login.signIn": "Entrar",
  "login.success": "Login realizado com sucesso!",
  "login.forgotPassword": "Esqueci minha senha",
  "login.rememberMe": "Lembrar de mim",
  "login.emailRequired": "E-mail é obrigatório",
  "login.passwordRequired": "Senha é obrigatória",
  "login.invalidCredentials": "E-mail ou senha incorretos",
  "login.tooManyAttempts": "Muitas tentativas de login. Aguarde alguns minutos e tente novamente.",
  "login.togglePasswordVisibility": "Mostrar/ocultar senha",

  // Forgot Password
  "forgotPassword.title": "Esqueceu sua senha?",
  "forgotPassword.subtitle": "Vamos ajudá-lo a redefini-la rapidamente.",
  "forgotPassword.recover": "Recuperar senha",
  "forgotPassword.emailPlaceholder": "Insira seu email para redefinir a senha",
  "forgotPassword.success": "E-mail de recuperação enviado com sucesso!",
  "forgotPassword.successTo": "Enviamos um link de recuperação para {email}.",
  "forgotPassword.sendToAnotherEmail": "Enviar para outro e-mail",
  "forgotPassword.spamHint": "Verifique também sua caixa de spam ou lixeira.",
  "forgotPassword.error": "Erro interno do servidor, tente novamente.",

  // Reset Password
  "resetPassword.title": "Redefinir Senha",
  "resetPassword.subtitle": "Crie uma nova senha segura",
  "resetPassword.newPassword": "Nova Senha",
  "resetPassword.confirmPassword": "Confirmar Senha",
  "resetPassword.newPasswordPlaceholder": "Digite sua nova senha",
  "resetPassword.confirmPasswordPlaceholder": "Confirme sua nova senha",
  "resetPassword.submit": "Redefinir Senha",
  "resetPassword.backToLogin": "Voltar ao Login",
  "resetPassword.requestNewLink": "Solicitar novo link",
  "resetPassword.success": "Senha redefinida com sucesso!",
  "resetPassword.error": "Erro interno do servidor, tente novamente.",
  "resetPassword.passwordRequired": "Senha é obrigatória",
  "resetPassword.confirmPasswordRequired": "Confirmação de senha é obrigatória",
  "resetPassword.criteriaTitle": "Critérios de segurança:",
  "resetPassword.min": "Mínimo {min} caracteres",
  "resetPassword.uppercase": "Pelo menos {min} letra maiúscula",
  "resetPassword.lowercase": "Pelo menos {min} letra minúscula",
  "resetPassword.digits": "Pelo menos {min} número",
  "resetPassword.symbols": "Pelo menos {min} símbolo (ex.: ! @ # $ % &)",
  "resetPassword.confirm": "Senhas devem coincidir",
  "resetPassword.tokenValid": "Token válido",
  "resetPassword.checkingToken": "Verificando link...",
  "resetPassword.redirectingIn": "Redirecionando em {seconds}s...",

  // Not Found
  "notFound.oops": "Ops!",
  "notFound.pageNotFound": "Página não encontrada",
  "notFound.forbidden":
    "Você não tem permissão para acessar esta página. Entre em contato com um administrador se acredita que deveria ter acesso.",
  "notFound.backToHome": "Voltar para início",

  // Drawer / Navigation
  "drawer.dashboard": "Dashboard",
  "drawer.cameras": "Câmeras",
  "drawer.liveStreams": "Transmissões ao Vivo",
  "drawer.subscriptions": "Assinaturas",
  "drawer.visitors": "Visitantes",
  "drawer.users": "Usuários",
  "drawer.links": "Links",
  "drawer.youtubeAccounts": "Contas YouTube",
  "drawer.reports": "Relatórios",
  "drawer.audit": "Auditoria",
  "drawer.help": "Ajuda",
  "help.title": "Ajuda",
  "help.subtitle": "Passo a passo dos processos do dia a dia.",
  "help.notes": "Avisos",
  "drawer.more": "Mais",

  // Country
  "country.BR": "Brasil",
  "country.UY": "Uruguai",
  "country.PT": "Portugal",
  "country.US": "Estados Unidos",
  "country.ES": "Espanha",

  // AppBar
  "appBar.editUser": "Editar Usuário",
  "appBar.changePassword": "Alterar Senha",
  "appBar.logout": "Sair",
  "appBar.build": "Versão",
  "appBar.build.unknown": "Desconhecida",

  // ChangePassword
  "changePassword.title": "Alterar Senha",
  "changePassword.currentPassword": "Senha Atual",
  "changePassword.currentPasswordPlaceholder": "Digite sua senha atual",
  "changePassword.success": "Senha alterada com sucesso!",
  "changePassword.error": "Erro ao alterar senha, tente novamente.",
  "appBar.theme.light": "Claro",
  "appBar.theme.dark": "Escuro",
  "appBar.role.ADMIN": "Administrador",
  "appBar.role.OWNER": "Proprietário",
  "appBar.role.SUPPORT": "Suporte",

  // System User Form
  "systemUserForm.success": "Usuário salvo com sucesso!",
  "systemUserForm.error": "Erro ao salvar usuário.",
  "systemUserForm.searchError": "Erro ao buscar estabelecimentos",
  "systemUserForm.create": "Criar e Enviar Convite",
  "systemUserForm.role": "Função",
  "systemUserForm.roleHelper": "Define o nível de acesso do usuário. ADMIN: acesso total. SUPORTE: acesso de leitura e gerenciamento. PROPRIETÁRIO: acesso apenas aos próprios estabelecimentos.",
  "systemUserForm.inviteInfo": "Um e-mail será enviado ao usuário com instruções para definir sua senha e ativar a conta.",
  "systemUserForm.activeHelper": "Usuários inativos não conseguem acessar o sistema.",
  "systemUserForm.establishmentsHiddenHint": "O campo de estabelecimentos foi ocultado, mas a seleção anterior foi mantida — ela volta a aparecer se você escolher o papel Proprietário novamente.",

  // User Register Accept
  "userRegisterAccept.title": "Finalizar Cadastro",
  "userRegisterAccept.subtitle": "Defina sua senha",
  "userRegisterAccept.description": "Você foi convidado(a) a acessar o sistema Meulance. Defina sua senha para ativar sua conta.",
  "userRegisterAccept.definePassword": "Defina sua senha de acesso",
  "userRegisterAccept.newPassword": "Nova senha",
  "userRegisterAccept.confirmPassword": "Confirmar senha",
  "userRegisterAccept.newPasswordPlaceholder": "Digite sua nova senha",
  "userRegisterAccept.confirmPasswordPlaceholder": "Confirme sua nova senha",
  "userRegisterAccept.submit": "Finalizar Cadastro",
  "userRegisterAccept.backToLogin": "Voltar ao Login",
  "userRegisterAccept.success":
    "Cadastro finalizado com sucesso! Você pode fazer login agora.",
  "userRegisterAccept.error": "Erro ao finalizar cadastro",
  "userRegisterAccept.redirectHint": "Você será redirecionado para o login em instantes.",
  "userRegisterAccept.invalidToken": "Token inválido ou expirado",

  // Generic Form
  "genericForm.loadError": "Erro ao carregar dados",
  "genericForm.fillAllRequiredFields": "Preencha todos os campos obrigatórios",

  // Generic List
  "genericList.rowsPerPage": "Linhas por página",
  "genericList.displayedRows": "{from}-{to} de {count}",
  "genericList.moreThan": "mais que {to}",

  // System User
  "systemUser.title": "Usuários",
  "systemUser.role": "Perfil",
  "systemUser.add": "Adicionar usuário",
  "systemUser.edit": "Editar usuário",
  "systemUser.delete": "Excluir usuário",
  "systemUser.createdAt": "Criado em",
  "systemUser.searchPlaceholder": "Pesquisar por nome ou email",
  "systemUser.sendPasswordReset": "Enviar email de redefinição de senha",
  "systemUser.passwordResetConfirmMessage": "Enviar e-mail de redefinição de senha para {email}?",
  "systemUser.fetchError": "Erro ao buscar usuários",
  "systemUser.deleteSuccess": "Usuário excluído com sucesso",
  "systemUser.passwordResetSuccess":
    "Email de redefinição de senha enviado com sucesso para {email}",
  "systemUser.passwordResetError":
    "Erro ao enviar email de redefinição de senha",
  "systemUser.yes": "Sim",
  "systemUser.no": "Não",
  "systemUser.empty": "Nenhum usuário encontrado.",
  "systemUser.selectHint": "Clique em uma linha para selecionar",

  // Establishment Form
  "establishmentForm.title": "Estabelecimento",
  "establishmentForm.success": "Estabelecimento salvo com sucesso!",
  "establishmentForm.error": "Erro ao salvar estabelecimento.",
  "establishmentForm.create": "Cadastrar",
  "establishmentForm.new": "Novo estabelecimento",
  "establishmentForm.timezone": "Timezone",
  "establishmentForm.channels": "Câmeras",
  "establishmentForm.channelsHint": "Cada câmera representa uma quadra deste estabelecimento.",
  "establishmentForm.channelsRestricted": "Apenas administradores/suporte podem gerenciar câmeras.",
  "establishmentForm.channelsSaveHint":
    "Alterações nas câmeras salvam imediatamente ao clicar no ícone de salvar de cada linha — não fazem parte do salvamento geral do formulário.",
  "establishmentForm.addChannel": "Adicionar câmera",
  "establishmentForm.channelName": "Nome da Câmera",
  "establishmentForm.actions": "Ações",
  "establishmentForm.confirmDeleteChannel":
    "Tem certeza que deseja excluir esta câmera? A alteração será persistida apenas após salvar o formulário.",
  "establishmentForm.private": "Estabelecimento privado",
  "establishmentForm.manageVisitors": "Gerenciar Visitantes",
  "establishmentForm.thumbnailLogoTitle": "Logo da miniatura das lives",
  "establishmentForm.thumbnailLogoHint": "Logo exibido na miniatura das lives deste estabelecimento no site (normalmente o logo do clube). Sem logo, a miniatura usa a imagem da transmissão no YouTube.",
  "establishmentForm.thumbnailLogoEmpty": "Nenhum logo enviado.",
  "establishmentForm.thumbnailLogoUpload": "Enviar logo",
  "establishmentForm.thumbnailLogoReplace": "Trocar logo",
  "establishmentForm.thumbnailLogoRemove": "Remover logo",
  "establishmentForm.thumbnailLogoConfirmRemove": "Remover o logo da miniatura? As lives voltarão a usar a imagem do YouTube.",
  "establishmentForm.thumbnailLogoSaved": "Logo da miniatura salvo!",
  "establishmentForm.thumbnailLogoRemoved": "Logo da miniatura removido.",
  "establishmentForm.thumbnailLogoError": "Erro ao salvar o logo da miniatura.",
  "establishmentForm.thumbnailLogoTooLarge": "O arquivo excede o limite de 2 MB.",
  "establishmentForm.thumbnailLogoRejected": "Arquivo não aceito. Envie uma única imagem PNG, JPEG ou GIF.",

  // Logo Editor
  "logoEditor.title": "Editor de Logos",
  "logoEditor.deleteConfirmTitle": "Excluir Logo",
  "logoEditor.deleteConfirmMessage":
    "Esta ação é irreversível. Deseja continuar mesmo assim?",
  "logoEditor.deleteSuccess": "Logo excluído com sucesso!",
  "logoEditor.deleteError": "Erro ao excluir logo.",
  "logoEditor.saveSuccess": "Logos salvos com sucesso!",
  "logoEditor.saveError": "Erro ao salvar logos.",
  "logoEditor.loadLogosError": "Erro ao carregar logos.",
  "logoEditor.loadSnapshotError": "Erro ao carregar snapshot.",

  // Upload
  "upload.unsupportedFile": "Arquivo não suportado",
  "upload.dropFiles": "Solte os arquivos aqui",
  "upload.acceptedFormats": "Formatos aceitos: PNG, JPEG, GIF",

  // Logo List
  "logoList.addLogos": "Adicione as logos",

  // Delete Dialog
  "deleteDialog.confirmMessage":
    "Esta ação é irreversível. Deseja continuar mesmo assim?",

  // Cam Layout Editor
  "camLayoutEditor.preserveAspectRatio":
    "Manter proporção ao redimensionar as logos",
  "camLayoutEditor.undoPosition": "Desfazer última posição (Ctrl+Z)",

  // Establishment List
  "establishmentList.title": "Estabelecimentos",
  "establishmentList.channels": "Câmeras",
  "establishmentList.createdAt": "Data de Criação",
  "establishmentHashList.title": "Links",
  "establishmentHashList.createLink": "Criar novo link",
  "establishmentHashList.address": "Endereço",
  "establishmentHashList.empty": "Nenhum link cadastrado",
  "establishmentHashList.fetchError": "Erro ao buscar os estabelecimentos",
  "establishmentHashList.deleteSuccess": "Link apagado com sucesso",
  "establishmentHashList.qrCode": "Ver QR Code",
  "establishmentList.searchPlaceholder": "Pesquisar",
  "establishmentList.toggleStatus": "Ativar/Desativar",
  "establishmentList.toggleConfirmTitle": "Ativar/Desativar estabelecimento",
  "establishmentList.toggleConfirmMessage":
    "Tem certeza que deseja {action} {name}?",
  "establishmentList.enable": "Ativar",
  "establishmentList.disable": "Desativar",
  "establishmentList.createLink": "Criar Link",
  "establishmentList.selectHint": "Selecione um estabelecimento para criar link",
  "establishmentList.fetchError": "Erro ao buscar os estabelecimentos",
  "establishmentList.statusUpdateSuccess": "Situação atualizada com sucesso",
  "establishmentList.deleteSuccess": "Estabelecimento apagado com sucesso",
  "establishmentList.empty": "Nenhum estabelecimento encontrado.",

  // Cameras
  "cameras.title": "Câmeras",
  "cameras.fetchError": "Erro ao buscar as câmeras",
  "cameras.noCameras": "Nenhuma câmera cadastrada",
  "cameras.noCamerasHintOperator": "Clique em \"Adicionar\" acima para cadastrar seu primeiro estabelecimento e câmeras.",
  "cameras.noCamerasHint": "Nenhum estabelecimento com câmeras foi encontrado para o seu usuário.",
  "cameras.replaysLabel": "Câmera ativa",
  "cameras.playPreview": "Iniciar preview ao vivo",
  "cameras.pausePreview": "Pausar preview ao vivo",
  "cameras.streamUnavailable": "Sem transmissão ao vivo no momento",
  "cameras.streamReplaced": "A pré-visualização foi interrompida porque outra pessoa abriu uma câmera. Tente novamente.",
  "cameras.offlineNoPreview": "Câmera offline",
  "cameras.onlineFilterAria": "Filtrar por status de conexão",
  "cameras.onlineFilterAll": "Todas",
  "cameras.onlineCount": "{online}/{total} online",
  "cameras.noCamerasForOnlineFilter": "Nenhuma câmera encontrada para esse filtro.",
  "cameras.offlineSince": "Offline desde {date}",
  "cameras.streamFallbackSnapshot":
    "Exibindo snapshot mais recente quando disponível.",
  "cameras.openLegacyPreview": "Abrir câmera ao vivo",
  "cameras.legacyPreviewUnavailable":
    "Não foi possível obter o URL legado desta câmera.",
  "cameras.toggleTooltip": "Ativar/Desativar",
  "cameras.toggleTooltipAdmin": "Apenas ADMIN",
  "cameras.toggleSuccess": "Situação atualizada com sucesso",
  "cameras.searchPlaceholder": "Pesquisar por câmera ou estabelecimento",
  "cameras.channelCreatedAt": "Câmera criada em {date}",
  "cameras.toggleConfirmTitle": "Ativar/Desativar quadra",
  "cameras.toggleConfirmMessage": "Tem certeza que deseja {action} {name}?",
  "cameras.enable": "Ativar",
  "cameras.disable": "Desativar",

  "cameras.channelUpdatedAt": "Câmera atualizada em {date}",
  "cameras.deleteSuccess": "Quadra apagada com sucesso",
  "cameras.deleteDialog.title": "Confirmar exclusão",
  "cameras.deleteDialog.titleEstablishment": "Excluir estabelecimento",
  "cameras.deleteDialog.titleChannel": "Excluir câmera",
  "cameras.deleteDialog.titleDevice": "Excluir dispositivo",
  "cameras.deleteDialog.messageEstablishment": "Tem certeza que deseja excluir o estabelecimento \"{name}\"? Todos os canais e dispositivos serão removidos.",
  "cameras.deleteDialog.messageChannel": "Tem certeza que deseja excluir a câmera \"{name}\"?",
  "cameras.deleteDialog.messageDevice": "Tem certeza que deseja excluir o dispositivo \"{name}\"?",
  "cameras.deleteDialog.message":
    "Você está prestes a excluir {name}. Esta ação não pode ser desfeita.",
  "cameras.deleteDialog.warning":
    "Ao confirmar, a remoção será permanente e irreversível.",
  "cameras.deleteDialog.checkbox":
    "Confirmo que desejo excluir e entendo que esta ação é irreversível.",
  "cameras.deleteDialog.confirm": "Sim, excluir",
  "deletionPreview.descriptionEstablishment":
    "Esta ação é permanente e vai excluir tudo o que pertence ao estabelecimento \"{name}\":",
  "deletionPreview.descriptionChannel":
    "Esta ação é permanente e vai excluir tudo o que pertence à câmera \"{name}\":",
  "deletionPreview.rowChannels": "Canais",
  "deletionPreview.rowVideos": "Vídeos",
  "deletionPreview.rowLogos": "Logos",
  "deletionPreview.rowFavorites": "Favoritos de visitantes",
  "deletionPreview.rowSavedVideos": "Vídeos salvos por visitantes",
  "deletionPreview.typeToConfirm": "Para confirmar, digite \"{name}\" abaixo:",
  "deletionPreview.loadError":
    "Não foi possível carregar o que será excluído. Tente novamente.",
  "deletionPreview.confirm": "Excluir permanentemente",
  // Cameras - Details
  "establishment.paymentBlocked.title": "Acesso bloqueado por atraso no pagamento",
  "establishment.paymentBlocked.message": "A assinatura deste clube está com pagamento pendente. Entre em contato com o financeiro pra regularizar e liberar o acesso de novo.",
  "cameras.details.title": "Detalhes da Câmera",
  "cameras.details.tabDetails": "Detalhes",
  "cameras.details.subtitle": "Edite o nome da câmera e acesse configurações",
  "cameras.details.cameraLabel": "Câmera",
  "cameras.details.saveSuccess": "Nome atualizado com sucesso",
  "cameras.details.saveError": "Erro ao atualizar nome",
  "cameras.details.videos": "Vídeos do Site",
  "cameras.details.logos": "Logos e Músicas",
  "cameras.details.privateCourt": "Quadra Privada",
  "cameraLogos.title": "Logos e Músicas",
  "cameraLogos.divergenceWarning":
    "As câmeras desta quadra têm marcas d'água diferentes. Escolha uma configuração para usar em todas.",
  "cameraLogos.fileTooLarge":
    "Um ou mais arquivos excedem o limite de 5MB e não foram adicionados.",
  "cameraLogos.logos": "Logos",
  "cameraLogos.musicHint": "Escolha uma trilha e salve para esta câmera.",
  "cameraLogos.defaultLogoLabel": "Logo padrão Meu Lance",
  "cameraLogos.defaultLogoHint":
    "Controle se o logo padrão do Meu Lance aparece no canto superior esquerdo.",
  "cameraLogos.defaultLogoPreviewHint":
    "O preview mantém a proporção real da transmissão. Em uma base de 1920 px, a logo padrão ocupa 276x67 px, a 60px do topo e 50px da esquerda.",
  "cameraLogos.defaultLogoSaved": "Logo padrão atualizado",
  "cameraLogos.defaultLogoSaveError": "Erro ao atualizar logo padrão",
  "cameraLogos.music": "Músicas",
  "cameraLogos.musicSaved": "Música salva com sucesso",
  "cameraLogos.musicSaveError": "Erro ao salvar música",
  "cameraLogos.noMusic": "Sem música",
  "cameraLogos.positionTitle": "Posicionamento de logos",
  "cameraLogos.positionSubtitle": "Arraste e redimensione na imagem base",
  "cameraLogos.libraryTitle": "Biblioteca de logos",
  "cameraLogos.librarySubtitle": "Envie, remova e organize seus logos",
  "logoEditor.loadingSnapshot": "Carregando snapshot...",
  "cameraPrivate.title": "Acesso Privado",
  "cameraPrivate.description":
    "Habilite o acesso privado e defina uma senha para restringir o acesso a esta câmera.",
  "cameraPrivate.enable": "Habilitar acesso privado",
  "cameraPrivate.password": "Senha",
  "cameraPrivate.passwordSetPlaceholder": "Senha definida — deixe em branco para manter",
  "cameraPrivate.passwordSetHelper": "Já existe uma senha configurada. Digite uma nova apenas se quiser substituí-la.",
  "cameraPrivate.saveSuccess": "Configurações salvas com sucesso",
  "cameraPrivate.authorizedTitle": "Usuários autorizados",
  "cameraPrivate.authorizedDescription":
    "Apenas os usuários listados aqui poderão assistir aos vídeos privados.",
  "cameraPrivate.manageAuthorized": "Gerenciar usuários autorizados",
  "cameraPrivate.passwordMode": "Privar com senha",
  "cameraPrivate.authorizedMode": "Privar com usuários autorizados",
  "cameraPrivate.mutuallyExclusive":
    "Você só pode ativar um método por vez. Ao ligar um, o outro é desligado.",
  "cameraPrivate.passwordHint":
    "Defina a senha para permitir acesso quando este modo estiver ativo.",
  "cameraPrivate.save": "Salvar privacidade",
  "cameraPrivate.saveHint":
    "Salva o modo atual (senha ou usuários autorizados).",
  // Create Link Dialog
  "createLinkDialog.title": "Criar link",
  "createLinkDialog.createButton": "Criar link",
  "createLinkDialog.success": "Link criado com sucesso",
  "createLinkDialog.error": "Erro ao criar link",
  "createLinkDialog.successTitle": "Link criado com sucesso",
  "createLinkDialog.linkLabel": "Link",
  "createLinkDialog.viewLinks": "Ver links",
  "createLinkDialog.qrCode": "Ver QR Code",
  "qrCodeDialog.title": "Código QR",
  "qrCodeDialog.alt": "QR Code do link",
  "qrCodeDialog.error": "Não foi possível gerar o QR Code",
  "qrCodeDialog.download": "Baixar PNG",
  "qrCodeDialog.downloadError": "Não foi possível baixar. Segure a imagem para salvá-la.",

  // Confirmations
  "establishmentList.confirmDeleteTitle": "Apagar estabelecimento",
  "establishmentList.confirmDeleteMessage":
    "Tem certeza que deseja apagar {name}? Esta ação apagará todas as quadras.",
  "cameras.confirmDeleteTitle": "Apagar quadra",
  "cameras.confirmDeleteMessage": "Tem certeza que deseja apagar {name}?",
  "video.delete_success": "Vídeo excluído com sucesso",
  "video.delete_error": "Não foi possível excluir o vídeo. Verifique sua conexão e tente novamente.",
  "video.restore_success": "Vídeo restaurado com sucesso",
  "video.restore_error": "Não foi possível restaurar o vídeo. Verifique sua conexão e tente novamente.",
  "cameraVideos.title": "Vídeos do Site",
  "cameraVideos.filters.date": "Data",
  "cameraVideos.filters.hour": "Hora",
  "cameraVideos.filters.allDates": "Todas as datas",
  "cameraVideos.filters.allHours": "Todas as horas",
  "cameraVideos.filters.today": "Hoje",
  "cameraVideos.filters.status": "Status",
  "cameraVideos.filters.active": "Ativos",
  "cameraVideos.filters.inactive": "Inativos",
  "cameraVideos.empty": "Nenhum vídeo encontrado para os filtros selecionados",
  "cameraVideos.emptyToday": "Nenhum vídeo hoje ainda.",
  "cameraVideos.confirmDeleteTitle": "Apagar vídeo",
  "cameraVideos.confirmDeleteMessage":
    "Tem certeza que deseja apagar o vídeo de {name}?",
  "cameraVideos.deleteVideo": "Excluir vídeo",
  "cameraVideos.thumbnailAlt": "Miniatura do vídeo",
  "cameraVideos.toggleStatus": "Ativar/Desativar vídeo",
  "cameraVideos.confirmToggleTitle": "Ativar/Desativar vídeo",
  "cameraVideos.confirmToggleMessage":
    "Tem certeza que deseja {action} o vídeo de {name}?",
  "cameraVideos.enable": "ativar",
  "cameraVideos.disable": "desativar",
  "cameraVideos.tabProcessed": "Processados",
  "cameraVideos.tabPending": "Pendentes",
  "cameraVideos.pendingWarning":
    "Apenas vídeos enviados nas últimas 48 horas podem ser recuperados. Vídeos mais antigos já foram removidos automaticamente do armazenamento de origem.",
  "cameraVideos.pendingEmpty": "Nenhum vídeo pendente encontrado.",
  "cameraVideos.pendingLoadError": "Não foi possível carregar os vídeos pendentes.",
  "cameraVideos.pendingName": "Arquivo",
  "cameraVideos.pendingLastModified": "Enviado em",
  "cameraVideos.reprocessSelected": "Reprocessar selecionados",
  "cameraVideos.reprocessSelectedCount": "Reprocessar {count} selecionado(s)",
  "cameraVideos.confirmReprocessTitle": "Reprocessar vídeos",
  "cameraVideos.confirmReprocessMessage":
    "Tem certeza que deseja reprocessar {count} vídeo(s)?",
  "cameraVideos.reprocessSuccess": "Reprocessamento disparado com sucesso.",
  "cameraVideos.reprocessPartialError": "{count} vídeo(s) falharam ao reprocessar.",
  "cameraVideos.reprocessError": "Não foi possível reprocessar os vídeos selecionados.",
  "cameraVideos.pendingRefresh": "Atualizar lista",
  "cameraVideos.pendingStatus": "Status",
  "cameraVideos.pendingStatusTriggered": "Reprocessamento disparado",
  "cameraVideos.pendingStatusError": "Falhou ao disparar",

  // Visitors List
  "visitorsList.title": "Visitantes",
  "visitorsList.selectedCount": "{count} selecionado(s)",
  "visitorsList.selectAll": "Selecionar todos",
  "visitorsList.deleteManyConfirm": "Tem certeza que deseja excluir {count} visitantes selecionados?",
  "visitorsList.phone": "Telefone",
  "visitorsList.establishment": "Estabelecimento",
  "visitorsList.createdAt": "Data de Cadastro",
  "visitorsList.searchPlaceholder": "Pesquisar",
  "visitorsList.searchMinChars": "Digite ao menos 3 caracteres",
  "visitorsList.exportAllHint": "Exporta a lista completa de visitantes (não respeita a seleção da tabela)",
  "visitorsList.deleteProgress": "Excluindo {done} de {total}...",
  "visitorsList.deleteSuccess": "Usuário apagado com sucesso",
  "visitorsList.enterEmail": "Digite um email",
  "visitorsList.exportSuccess": "Solicitação realizada",
  "visitorsList.empty": "Nenhum visitante encontrado.",

  // Export Visitors Dialog
  "exportVisitorsDialog.confirmMessage": "Deseja exportar todos os contatos?",
  "exportVisitorsDialog.explanation": "Você receberá um arquivo com a lista completa de visitantes por e-mail em alguns minutos.",
  "exportVisitorsDialog.emailPlaceholder": "Digite seu email",

  // Establishment Visitor
  "establishmentVisitor.title": "Visitantes Permitidos",
  "establishmentVisitor.createdAt": "Data de Criação",
  "establishmentVisitor.emailPlaceholder": "email1@exemplo.com",
  "establishmentVisitor.emailHelper":
    "Informe o email para verificar a associação ou adicionar",
  "establishmentVisitor.notFoundAddHint":
    "Nenhum visitante encontrado com esse e-mail. Clique em Adicionar para cadastrá-lo.",
  "establishmentVisitor.modeSearch": "Buscando visitante",
  "establishmentVisitor.modeAdd": "Nenhum resultado — adicionar novo visitante",
  "establishmentVisitor.selectedCount": "{count} selecionado(s)",
  "establishmentVisitor.deleteSelected": "Excluir selecionados",
  "establishmentVisitor.empty": "Nenhum visitante encontrado.",
  "establishmentVisitor.loadError": "Erro ao carregar visitantes permitidos",
  "establishmentVisitor.addSuccess": "Email adicionado com sucesso",
  "establishmentVisitor.addError": "Erro ao adicionar emails",
  "establishmentVisitor.addEmailNotFound": "O e-mail {email} ainda não tem cadastro de visitante — o acesso não foi concedido. Peça para a pessoa se cadastrar e tente novamente.",
  "establishmentVisitor.deleteConfirm":
    "Confirma a exclusão dos seguintes emails?",
  "establishmentVisitor.deleteSuccess": "Visitantes removidos com sucesso",
  "establishmentVisitor.deleteError": "Erro ao excluir visitantes",

  // Dashboard
  "dashboard.noCameras": "Nenhuma câmera encontrada.",
  "dashboard.videoViews": "Visualização de Vídeos",
  "dashboard.videoDownloads": "Downloads de Vídeos",
  "dashboard.videos": "Vídeos Gerados",
  "dashboard.adminTitle": "Painel de Controle",
  "dashboard.ownerProfileTitle": "Perfil do Proprietário",
  "dashboard.sectionOperational": "Status das Câmeras",
  "dashboard.sectionMetrics": "Métricas de Audiência",
  "dashboard.sectionLives": "Transmissões",
  "dashboard.sectionAlerts": "Alertas",
  "dashboard.noLivesToShow": "Nenhuma transmissão para mostrar.",
  "dashboard.noAlerts": "Nenhum alerta no momento.",
  "dashboard.alertCamerasOffline": "{count} câmera(s) offline. Toque para verificar.",
  "dashboard.alertYoutubeReconnect": "Sua conexão com o YouTube precisa ser renovada. Toque para reconectar.",
  "dashboard.alertPaymentPending": "{count} transmissão(ões) com pagamento pendente. Toque para ver.",
  "dashboard.quickActionCreateLive": "Nova transmissão",
  "dashboard.quickActionManageCameras": "Gerenciar câmeras",
  "dashboard.quickActionConfigureLogos": "Configurar logos",
  "dashboard.quickActionConnectYoutube": "Conectar YouTube",
  "dashboard.quickActionScoreboard": "Acessar placar",
  "dashboard.filtersLabel": "Filtros",
  "dashboard.stateFilterLabel": "Estado",
  "dashboard.cityFilterLabel": "Cidade",
  "dashboard.projectedImpressions": "Impressões Projetadas",
  "dashboard.cameraStatusTitle": "Status das Câmeras",
  "dashboard.cameraOnline": "Online",
  "dashboard.cameraOffline": "Offline",
  "dashboard.cameraName": "Nome",
  "dashboard.cameraStatusColumn": "Status Câmera",
  "dashboard.cameraLastEvent": "Último Evento",
  "dashboard.cameraLastCommunication": "Última Comunicação",
  "dashboard.cameraLastCheck": "Última Verificação",
  "dashboard.cameraSdStatus": "Status Cartão SD",
  "dashboard.cameraButtonStatus": "Status Botoeira",
  "dashboard.buttonOk": "OK",
  "dashboard.buttonNoShort": "Sem curto",
  "dashboard.buttonOffline": "Offline",
  "dashboard.buttonNotConfigured": "Não configurado",
  "dashboard.buttonHealthBadTitle": "Botoeira com problema",
  "dashboard.buttonHealthOkHint": "Botoeira funcionando normalmente, sem curto-circuito detectado.",
  "dashboard.buttonHealthReasonVeryLong": "Vídeo acima de 5 minutos",
  "dashboard.buttonHealthReasonThreeLong":
    "3 vídeos consecutivos acima de 2 minutos",
  "dashboard.buttonShortCircuit": "Em curto",
  "dashboard.establishmentLabel": "Estabelecimento",
  "dashboard.establishmentLabelCameras": "Estabelecimento (câmeras)",
  "dashboard.establishmentLabelMetrics": "Estabelecimento (métricas)",
  "dashboard.formatHelper": "Aplica-se a todos os gráficos abaixo",
  "dashboard.sdFormat": "Formatar cartão SD",
  "dashboard.sdResetHint": "Resetar cartão",
  "dashboard.sdFormatConfirm":
    "Deseja formatar o cartão SD desta câmera? Essa ação pode levar alguns minutos.",
  "dashboard.sdFormatSuccess": "Formatação solicitada.",
  "dashboard.sdFormatError": "Erro ao solicitar formatação do cartão SD.",
  "datePicker.month": "Mês",
  "datePicker.year": "Ano",
  "datePicker.clear": "Limpar",
  "datePicker.today": "Hoje",
  "timePicker.hour": "Hora",
  "timePicker.minute": "Minuto",
  "timePicker.now": "Agora",
  "timePicker.period": "Período",
  "timePicker.am": "AM",
  "timePicker.pm": "PM",
  "dashboard.sdOk": "OK",
  "dashboard.sdError": "Erro",
  "dashboard.statusUnknown": "N/D",
  "dashboard.daysWithoutEvent": "+{days} dias sem evento",
  "dashboard.loadError": "Erro ao carregar dados do dashboard",
  "dashboard.cameraStatusPartialError": "Erro ao carregar status de {count} estabelecimento(s).",
  "dashboard.cameraStatusError": "Erro ao carregar status das câmeras.",
  "dashboard.metricsRestricted": "As métricas de audiência estão disponíveis para administradores, suporte e proprietários.",

  // Live Streams
  "liveStreams.title": "Transmissões ao Vivo",
  "liveStreams.subtitle": "{place}",
  "liveStreams.subtitleEmpty": "Selecione um estabelecimento",
  "liveStreams.tabs.schedule": "Agendamento",
  "liveStreams.newLive": "Nova transmissão",
  "liveStreams.stepWhereWhen": "Onde e quando",
  "liveStreams.stepWhere": "Onde",
  "liveStreams.stepConfiguration": "Configuração",
  "liveStreams.stepAudioReview": "Áudio e revisão",
  "liveStreams.reviewTitle": "Resumo da transmissão",
  "liveStreams.reviewSchedule": "Data/Horário:",
  "liveStreams.tabs.lives": "Histórico de Transmissão",
  "liveStreams.tabs.playlists": "Playlists",
  "liveStreams.tabs.media": "Mídias",
  "youtubeConnection.title": "Conexão YouTube",
  "youtubeConnection.subtitle": "Vínculo da sua conta com o YouTube.",
  "youtubeConnection.prerequisitesAria": "Inscritos no YouTube para transmissão ao vivo",
  "youtubeConnection.prerequisitesInfo":
    "O YouTube costuma exigir no mínimo 50 inscritos no canal para liberar transmissão ao vivo. Confira na Central de Ajuda do YouTube caso as regras mudem.",
  "youtubeConnection.connected": "Conectado",
  "youtubeConnection.disconnected": "Desconectado",
  "youtubeConnection.requiresReconnect": "Reconexão necessária",
  "youtubeConnection.renewalError": "Falha temporária na renovação",
  "youtubeConnection.lastSyncedAt": "Última sincronização: {date}",
  "youtubeConnection.reconnectPromptTitle": "Sua conexão com o YouTube precisa ser renovada",
  "youtubeConnection.reconnectPromptMessage":
    "A conexão da sua conta do YouTube expirou. Enquanto ela não for renovada, novas transmissões podem falhar ou ficar indisponíveis. Deseja reconectar agora?",
  "youtubeConnection.reconnectPromptCta": "Reconectar agora",
  "youtubeConnection.reconnectPromptLater": "Lembrar depois",
  "youtubeConnection.connect": "Conectar conta",
  "youtubeConnection.renewOAuth": "Renovar vínculo",
  "youtubeConnection.refreshConnection": "Atualizar conexão",
  "youtubeConnection.reconnect": "Reconectar conta",
  "youtubeConnection.disconnect": "Desconectar",
  "youtubeConnection.support": "Falar com suporte",
  "youtubeConnection.supportWhatsappMessage":
    "Olá! Preciso de ajuda com a conexão YouTube no Meu Lance.",
  "youtubeConnection.blockingWarning":
    "Conecte sua conta do YouTube para agendar transmissões ao vivo.",
  "youtubeConnection.disconnectNotice": "Conta do YouTube desvinculada.",
  "youtubeConnection.disconnectConfirmTitle": "Desconectar a conta do YouTube?",
  "youtubeConnection.disconnectConfirmBody":
    "Você precisará conectar a conta novamente para agendar e gerenciar transmissões pelo app.",
  "youtubeAdminAccounts.title": "Contas YouTube",
  "youtubeAdminAccounts.column.channel": "Canal",
  "youtubeAdminAccounts.column.scheduleLimit": "Limite de agendamentos",
  "youtubeAdminAccounts.column.lastSyncedAt": "Última sincronização",
  "youtubeAdminAccounts.status.connected": "Conectado",
  "youtubeAdminAccounts.status.disconnected": "Desconectado",
  "youtubeAdminAccounts.status.requiresReconnect": "Reconexão necessária",
  "youtubeAdminAccounts.status.renewalError": "Falha temporária na renovação",
  "youtubeAdminAccounts.connect": "Conectar",
  "youtubeAdminAccounts.unlink": "Desvincular",
  "youtubeAdminAccounts.ownerManagedChip": "Proprietário",
  "youtubeAdminAccounts.empty": "Nenhuma conta cadastrada.",
  "youtubeAdminAccounts.createTitle": "Nova conta YouTube",
  "youtubeAdminAccounts.editTitle": "Editar conta YouTube",
  "youtubeAdminAccounts.form.name": "Nome",
  "youtubeAdminAccounts.form.scheduleLimit": "Limite de agendamentos",
  "youtubeAdminAccounts.form.active": "Ativa",
  "youtubeAdminAccounts.createSuccess": "Conta criada. Clique em \"Conectar\" para vincular ao Google.",
  "youtubeAdminAccounts.updateSuccess": "Conta atualizada.",
  "youtubeAdminAccounts.unlinkSuccess": "Conta desvinculada do Google.",
  "youtubeAdminAccounts.deleteSuccess": "Conta removida.",
  "youtubeAdminAccounts.unlinkConfirmTitle": "Desvincular esta conta do Google?",
  "youtubeAdminAccounts.unlinkConfirmMessage":
    "A conta \"{name}\" deixará de transmitir até que alguém a conecte novamente.",
  "youtubeAdminAccounts.deleteConfirmTitle": "Excluir esta conta?",
  "youtubeAdminAccounts.deleteConfirmMessage":
    "A conta \"{name}\" será removida permanentemente. Essa ação não pode ser desfeita.",
  "youtubeAdminAccounts.deactivateConfirmTitle": "Desativar esta conta?",
  "youtubeAdminAccounts.deactivateConfirmMessage":
    "A conta \"{name}\" para de poder ser usada em novas transmissões (agendamentos ativos no momento: {count}).",
  "liveDetails.noYoutubePoolAccountAvailable":
    "Nenhuma conta YouTube do pool está ativa e conectada no momento. Conecte ou reative uma conta antes de agendar.",
  "liveStreams.ownerScheduledNoticeTitle": "Transmissão agendada com sucesso",
  "liveStreams.ownerScheduledNoticeBody":
    "Agora é só aguardar o início da transmissão. Você pode conferir os dados nesta tela e ainda editar o que precisar.",
  "liveStreams.filterDescription": "Filtro por descrição",
  "liveStreams.filterDevice": "Filtro por dispositivo",
  "liveStreams.filterEstablishment": "Filtro por estabelecimento",
  "liveStreams.filterHistoryStatus": "Filtro por status",
  "liveStreams.historyStatusWaiting": "Aguardando",
  "liveStreams.historyStatusCompleted": "Completados",
  "liveStreams.filterAll": "Todos",
  "liveStreams.youtubeAccount": "Conta YouTube",
  "liveStreams.youtubeAccountPlaceholder": "Selecione a conta YouTube",
  "liveStreams.youtubeAccountOwn": "Minha conta (conectada)",
  "liveStreams.scheduleAdminOnly":
    "Data e horário não podem mais ser alterados: a transmissão já foi finalizada.",
  "liveStreams.ownerConfirmNotice":
    "Ao confirmar, você autoriza a cobrança para realizar esta transmissão. A data e o horário não poderão ser alterados depois.",
  "liveStreams.ownerScheduleConfirmBody":
    "Deseja confirmar o agendamento para {place} - {court} no dia {date}, às {time}, com duração de {duration}?",
  "liveStreams.ownerScheduleSummary":
    "Agendamento: {place} - {court} no dia {date}, às {time}, com duração de {duration}.",
  "liveStreams.ownerScheduleFieldPlaceCourt": "Estabelecimento/Quadra:",
  "liveStreams.ownerScheduleFieldTime": "Hora:",
  "liveStreams.ownerScheduleFieldDuration": "Duração:",
  "liveStreams.upcomingTitle": "Próximas alterações de status de LIVES",
  "liveStreams.name": "Título da Transmissão",
  "liveStreams.playlist": "Playlist",
  "liveStreams.period.title": "Nova transmissão por período",
  "liveStreams.period.startDate": "Data de início",
  "liveStreams.period.endDate": "Data de fim",
  "liveStreams.period.dailyStartTime": "Horário de início",
  "liveStreams.period.dailyEndTime": "Horário de fim",
  "liveStreams.period.dailyTimeInvalid": "O horário de fim deve ser depois do horário de início.",
  "liveStreams.period.preview": "Ver resumo",
  "liveStreams.period.confirm": "Criar transmissão",
  "liveStreams.period.previewLoading": "Calculando resumo...",
  "liveStreams.period.daysCount": "{count, plural, one {# dia de transmissão} other {# dias de transmissão}}",
  "liveStreams.period.willSplitWarning":
    "{count, plural, one {# dia ultrapassa 9 horas} other {# dias ultrapassam 9 horas}} e será dividido automaticamente em Parte 1 e Parte 2.",
  "liveStreams.period.retry": "Tentar novamente",
  "liveStreams.period.giveUp": "Desistir",
  "liveStreams.period.viewDetails": "Ver detalhes",
  "liveStreams.period.status.SCHEDULED": "Agendado",
  "liveStreams.period.status.CREATED": "Criado",
  "liveStreams.period.status.FAILED": "Falhou",
  "liveStreams.period.status.SKIPPED": "Ignorado",
  "liveStreams.period.status.ABANDONED": "Desistido",
  "liveStreams.period.ownerMaxDaysExceeded":
    "Você pode agendar no máximo {days} dias por período.",
  "liveStreams.period.billingAwaiting":
    "Aguardando confirmação de todos os agendamentos para liberar o pagamento.",
  "liveStreams.period.billingConfirmed":
    "Todos os agendamentos foram confirmados — pagamento liberado.",
  "liveStreams.period.billingConfig.title": "Configurar taxa diária",
  "liveStreams.period.billingConfig.dailyRate": "Taxa diária (R$)",
  "liveStreams.period.billingConfig.invalidRate": "Informe um valor maior que zero.",
  "liveStreams.status": "Status",
  "liveStreams.nextChange": "Próxima alteração",
  "liveStreams.noUpcoming": "Nenhuma alteração prevista",
  "liveStreams.livesTitle": "Histórico",
  "liveStreams.tabUpcoming": "Próximas",
  "liveStreams.tabPast": "Anteriores",
  "liveStreams.noLives": "Nenhuma live encontrada",
  "liveStreams.startsAt": "Início:",
  "liveStreams.endsAt": "Fim:",
  "liveStreams.paymentStatusLabel": "Status pagamento:",
  "liveStreams.paymentColumn": "Pagamento",
  "liveStreams.paymentStatusPaid": "Pago",
  "liveStreams.paymentStatusPending": "Pendente",
  "liveStreams.paymentStatusDirectFinance": "Direto com financeiro",
  "liveStreams.paymentStatusAwaitingSchedules": "Aguardando agendamentos",
  "liveStreams.paymentStatusUnknown": "Não informado",
  "liveStreams.refreshPaymentStatus": "Atualizar pagamento",
  "liveStreams.paymentStatusUpdatedPaid": "Status de pagamento atualizado: pago.",
  "liveStreams.paymentStatusUpdatedPending":
    "Status de pagamento atualizado: ainda pendente.",
  "liveStreams.paymentStatusUpdatedDirectFinance":
    "Status de pagamento atualizado: direto com financeiro.",
  "liveStreams.selectLive": "Selecione uma live para editar",
  "liveStreams.pendingTitle": "Transmissões Pendentes",
  "liveStreams.openLinkAdmin": "Abrir Link/Adm",
  "liveStreams.openAdmin": "Abrir Admin",
  "liveStreams.openDetails": "Detalhes",
  "liveStreams.configureTitle": "Configurações",
  "liveStreams.configureSubtitle": "Personalize logos, músicas e placar",
  "liveStreams.logosTitle": "Logos",
  "liveStreams.logosDesc": "Envie e posicione logos na transmissão",
  "liveStreams.uploadLogos": "Enviar logos",
  "liveStreams.bannerTitle": "Banners",
  "liveStreams.bannerDesc": "Gerencie banners da transmissão",
  "liveStreams.manageBanners": "Gerenciar banners",
  "liveStreams.startAt": "Início",
  "liveStreams.startTime": "Hora início",
  "liveStreams.endAt": "Fim",
  "liveStreams.endTime": "Hora fim",
  "liveStreams.estimatedPrice": "Valor estimado: {price}",
  "liveStreams.priceFormulaHint": "R$3 na 1ª hora + R$2 por hora adicional, até R$15.",
  "liveStreams.endTimeHour": "Hora",
  "liveStreams.endTimeMinute": "Minutos",
  "liveStreams.maxTwoHoursHint": "Duração fixa: 2 horas",
  "liveStreams.maxNineHoursHint":
    "A transmissão não pode passar de 9 horas a partir da data de início.",
  "liveStreams.scoreType": "Tipo de placar",
  "liveStreams.selectPlaceholder": "Selecione...",
  "liveStreams.scoreSimple": "Simples",
  "liveStreams.scorePadel": "Pádel",
  "liveStreams.scoreVolley": "Vôlei",
  "liveStreams.scoreCustom": "Personalizado",
  "liveStreams.musicTitle": "Música",
  "liveStreams.musicWithBackground": "Com música de fundo",
  "liveStreams.musicWithoutBackground": "Sem música",
  "liveStreams.musicPlaybackHint":
    "As músicas serão tocadas em sequência e repetidas até o fim da transmissão.",
  "liveStreams.musicPreviewList": "Prévia das músicas",
  "liveStreams.musicPreviewUnavailable":
    "Nenhuma música disponível para prévia no momento.",
  "liveStreams.playlist1": "Playlist 1",
  "liveStreams.playlist2": "Playlist 2",
  "liveStreams.playlist3": "Playlist 3",
  "liveStreams.playlist4": "Playlist 4",
  "liveStreams.playlist5": "Playlist 5",
  "liveStreams.adminLink": "Link do administrador",
  "liveStreams.adminLinkPlaceholder":
    "Copie o link para acessar o painel do administrador",
  "liveStreams.advanced": "Avançado",
  "liveStreams.templateHelp": "Selecione um template (se disponível)",
  "liveStreams.template": "Template",
  "liveStreams.createAndPay": "Salvar",
  "liveStreams.directFinancePayment": "Pagamento direto no financeiro",
  "liveStreams.noTemplates": "Nenhum template disponível para esta seleção.",
  "liveStreams.noCourts": "Nenhuma quadra disponível para esta seleção.",
  "liveStreams.noEstablishmentsFound": "Nenhum estabelecimento encontrado.",
  "liveStreams.draftRestoredHint": "Continuando um agendamento que você havia começado antes.",
  "liveStreams.establishmentsLoadError": "Erro ao carregar estabelecimentos. Tente novamente.",
  "liveStreams.disabledCreating": "Criando transmissão...",
  "liveStreams.disabledYoutubeNotConnected": "Conecte sua conta do YouTube primeiro",
  "liveStreams.disabledLoading": "Carregando...",
  "liveStreams.disabledPastStart": "Data/hora de início no passado",
  "liveStreams.disabledTooFar": "Data de início muito distante (máx 48h)",
  "liveStreams.disabledInvalidEnd": "Horário de fim inválido (máx 9h)",
  "liveStreams.disabledSelectEstablishment": "Selecione um estabelecimento",
  "liveStreams.disabledSelectCamera": "Selecione uma câmera/quadra",
  "liveStreams.disabledSelectPlaylist": "Selecione uma playlist",
  "liveStreams.playlistRequired": "Selecione uma playlist.",
  "liveStreams.playlistAdminOnly":
    "A playlist só pode ser alterada por um administrador.",
  "liveStreams.playlistLockedAfterBind":
    "A playlist não pode ser alterada após vinculada a esta transmissão.",
  "liveStreams.playlistMissingMapping":
    "Este estabelecimento não tem playlist vinculada. Um administrador precisa vincular em Playlists.",
  "liveStreams.noPlaylistForEstablishment":
    "Nenhuma playlist vinculada para este estabelecimento.",
  "liveStreams.period.startWindowHint": "O primeiro dia só aceita horários a partir de {from}.",
  "liveStreams.startTooSoon": "Agende com pelo menos {minutes} minutos de antecedência (a partir de {time}).",
  "liveStreams.startWindowHint": "Disponível de {from} até {to}.",
  "liveStreams.pastStart": "Não é possível agendar no passado.",
  "liveStreams.startTooFar":
    "Você só pode agendar com até {hours} horas de antecedência.",
  "liveStreams.invalidRange": "Intervalo inválido.",
  "liveDetails.onlyWaitingOrRunningSchedulesEditable":
    "Somente transmissões aguardando ou em andamento podem ser editadas.",
  "liveDetails.scheduleNotIdentified": "Não foi possível identificar o agendamento para edição.",
  "liveStreams.scheduleConflictPeriod":
    "O estabelecimento e a quadra escolhidos já possuem um agendamento dentro do período selecionado.",
  "liveStreams.mockCreated":
    "Agendamento mockado localmente para testes (backend indisponível).",
  "liveStreams.minDuration": "Duração mínima: {minutes} min.",
  "liveStreams.maxDuration": "Duração máxima: {minutes} min.",

  // Live Status
  "liveStatus.waitStart": "Aguardando",
  "liveStatus.started": "Iniciado",
  "liveStatus.finished": "Finalizado",
  "liveStatus.failed": "Falhou",
  "liveStatus.canceled": "Cancelado",

  // Live Payment
  "livePayment.title": "Pagamento",
  "livePayment.subtitle": "Finalize o pagamento para concluir a transmissão",
  "livePayment.pending": "Pendente",
  "livePayment.billedValueLabel": "Valor cobrado",
  "livePayment.paidAtLabel": "Data do pagamento",
  "livePayment.paymentMethodLabel": "Forma de pagamento",
  "livePayment.back": "Voltar",
  "livePayment.pay": "Pagar agora",
  "livePayment.continue": "Continuar",
  "livePayment.autoContinueToast": "Pagamento confirmado! Concluindo o agendamento...",
  "livePayment.autoContinueCountdown": "Redirecionando em {seconds}s...",
  "livePayment.cancelAutoContinue": "Cancelar redirecionamento automático",
  "livePayment.paymentPendingHint":
    "Pagamento pendente. Você pode abrir o Mercado Pago para concluir.",
  "livePayment.checkingPayment": "Verificando pagamento...",
  "livePayment.noPaymentYet": "Pagamento ainda não realizado.",
  "livePayment.paymentConfirmed": "Pagamento confirmado.",
  "livePayment.noPaymentRequired":
    "Nenhum pagamento necessário. Você pode continuar.",
  "livePayment.hint":
    "Após o pagamento, você será redirecionado para configurar a transmissão.",
  "livePayment.fallbackName": "Transmissão",
  "livePayment.fallbackPlace": "Estabelecimento",
  "livePayment.fallbackDevice": "Câmera",
  "livePayment.openInNewTabHint":
    "Se o botão de pagamento não aparecer, use o link abaixo para abrir o checkout em nova aba.",
  "livePayment.openInNewTab": "Abrir checkout em nova aba",
  "livePayment.verifyPayment": "Já paguei",
  "livePayment.statusRefunded":
    "O pagamento anterior foi estornado. Efetue um novo pagamento.",
  "livePayment.statusRejected":
    "O pagamento foi recusado. Tente novamente ou use outra forma de pagamento.",
  "livePayment.statusCancelled":
    "O pagamento foi cancelado. Efetue um novo pagamento.",
  "livePayment.statusInProcess":
    "Pagamento em processamento. Aguarde a confirmação.",
  "livePayment.statusInMediation":
    "Pagamento em análise. Entre em contato com o Mercado Pago se precisar de ajuda.",
  "livePayment.statusChargedBack":
    "Houve um estorno. Efetue um novo pagamento.",

  // Live Link
  "liveLink.title": "Transmissão",
  "liveLink.subtitle": "Link do administrador para configurar a transmissão",
  "liveLink.adminLinkTitle": "Link do administrador",
  "liveLink.adminLinkPlaceholder":
    "Link será exibido após a criação da transmissão",
  "liveLink.adminLinkHint":
    "Use este link para acessar o painel e configurar logos, músicas e placar.",
  "liveLink.openNarratorPanel": "Abrir painel do administrador",

  "liveBranding.schedulingTitle": "Configurando transmissão",
  "liveBranding.schedulingBody":
    "Estamos preparando vídeo, logos e conexão da câmera. Isso pode levar alguns segundos.",
  "liveBranding.ownerPaymentTitle": "Confirmação",
  "liveBranding.ownerPaymentConfirm": "Confirmar",
  "liveBranding.ownerPaymentConfirmed":
    "Solicitação enviada. Nossa administração entrará em contato para a cobrança.",

  // Live Admin
  "liveAdmin.title": "Admin da Transmissão",
  "liveAdmin.subtitle": "Gerencie placar, banners, logos e música",
  "liveAdmin.subtitleWithLive": "{name} · {device} · {start} → {end}",
  "liveAdmin.openYoutube": "Abrir no YouTube",
  "liveAdmin.scoreTitle": "Placar",
  "liveAdmin.team1": "Time 1",
  "liveAdmin.team2": "Time 2",
  "liveAdmin.bannersTitle": "Banners",
  "liveAdmin.bannersSubtitle": "Selecione um banner para exibir na transmissão",
  "liveAdmin.loopingMode": "Modo alternar automaticamente",
  "liveAdmin.on": "Ligado",
  "liveAdmin.off": "Desligado",
  "liveAdmin.narrationTitle": "Narração",
  "liveAdmin.micStatus": "Microfone: {status}",
  "liveAdmin.toggleMic": "Ativar/Desativar microfone",
  "liveAdmin.startNarration": "Iniciar narração",
  "liveAdmin.stopNarration": "Parar narração",
  "liveAdmin.narrationHint": "A narração é apenas um placeholder por enquanto.",
  "liveAdmin.logosTitle": "Logos",
  "liveAdmin.onboardingHint": "1. Envie sua logo na biblioteca à direita → 2. Arraste para a posição desejada no quadro acima → 3. Clique em \"Salvar\".",
  "liveAdmin.musicSectionTitle": "Música de fundo",
  "liveAdmin.unsavedChanges": "Alterações não salvas",
  "liveAdmin.selectLogo": "Selecionar logo para editar",
  "liveAdmin.addLogo": "Adicionar logo",
  "liveAdmin.newLogo": "Novo logo…",
  "liveAdmin.deleteLogo": "Excluir logo",
  "liveAdmin.addLogoTitle": "Adicionar logo",
  "liveAdmin.add": "Adicionar",
  "liveAdmin.cancel": "Cancelar",
  "liveAdmin.image": "Imagem",
  "liveAdmin.searchImage": "Buscar imagem…",
  "liveAdmin.searchPlaylist": "Buscar playlist…",
  "liveAdmin.position": "Posição",
  "liveAdmin.position.TOP_LEFT": "Superior esquerdo",
  "liveAdmin.position.TOP_RIGHT": "Superior direito",
  "liveAdmin.position.BOT_LEFT": "Inferior esquerdo",
  "liveAdmin.position.BOT_RIGHT": "Inferior direito",
  "liveAdmin.offsetX": "Offset X",
  "liveAdmin.offsetY": "Offset Y",
  "liveAdmin.saveLogo": "Salvar logo",
  "liveAdmin.saveAllLogos": "Salvar",
  "liveAdmin.saveLogosConfirmTitle": "Salvar logos?",
  "liveAdmin.saveLogosConfirmBody":
    "Você alterou configurações de logos. Deseja salvar antes de salvar a playlist?",
  "liveAdmin.continueWithoutSavingLogos": "Salvar playlist sem salvar logos",
  "liveAdmin.saveLogosAndContinue": "Salvar logos e salvar playlist",
  "liveAdmin.emptyLogoError":
    "Insira uma imagem ou remova a logo vazia antes de salvar.",
  "liveAdmin.reservedArea": "Área reservada (propaganda)",
  "liveAdmin.cameraView": "Visão da Câmera",
  "liveAdmin.dragHint":
    "Dica: arraste o logo para ajustar a posição no vídeo. Você também pode aumentar ou diminuir o tamanho da logo.",
  "liveAdmin.musicTitle": "Música",
  "liveAdmin.playlist": "Playlist",
  "liveAdmin.savePlaylist": "Salvar playlist",
  "liveAdmin.uploadLogoMedia": "Enviar Midia para Logo",

  // Live Playlists
  "livePlaylists.title": "Playlists",
  "livePlaylists.add": "Nova playlist",
  "livePlaylists.establishment": "Estabelecimento",
  "livePlaylists.id": "ID",
  "livePlaylists.name": "Descrição",
  "livePlaylists.youtubeId": "YouTube ID",
  "livePlaylists.youtubeHint":
    "Deixe em branco para criar no YouTube automaticamente.",
  "livePlaylists.youtubeAccountId": "Conta YouTube",
  "livePlaylists.youtubeAccountIdHint": "Escolha a conta que será dona desta playlist no YouTube.",
  "livePlaylists.filterYoutubeAccount": "Filtrar por conta YouTube",
  "livePlaylists.youtubeAccountColumn": "Conta YouTube",
  "livePlaylists.actions": "Ações",
  "livePlaylists.empty": "Nenhuma playlist cadastrada.",
  "livePlaylists.createTitle": "Criar playlist",
  "livePlaylists.editTitle": "Editar playlist",
  "livePlaylists.save": "Salvar",
  "livePlaylists.cancel": "Cancelar",

  // Live Media Library
  "liveMedia.title": "Mídias",
  "liveMedia.upload": "Enviar mídia",
  "liveMedia.empty": "Nenhuma mídia cadastrada.",

  // Live Workspace
  "liveWorkspace.tabs.detalhes": "Detalhes",
  "liveWorkspace.tabs.pagamento": "Pagamento",
  "liveWorkspace.tabs.branding": "Logos/Músicas",
  "liveWorkspace.tabs.placar": "Placar",
  "liveWorkspace.comingSoon": "Em breve nesta aba.",

  // Live Details
  "liveDetails.title": "Detalhes da Transmissão",
  "liveDetails.scoreboardButton": "Placar",
  "liveDetails.back": "Voltar",
  "liveDetails.openBranding": "Logos/Músicas",
  "liveDetails.payRequiredToConfigure":
    "Pague a transmissão para acessar logos e configurar.",
  "liveDetails.scheduleChangeDuringStreamHint": "Alterações de agendamento durante a transmissão podem exigir reinício para aplicar imediatamente.",
  "liveDetails.restartDialogTitle": "Alteração durante transmissão",
  "liveDetails.restartDialogBody": "Para que as mudanças ocorram durante a transmissão, será necessário reiniciar. Deseja reiniciar agora ou mais tarde?",
  "liveDetails.restartLater": "Reiniciar mais tarde",
  "liveDetails.restartNow": "Reiniciar agora",
  "liveDetails.tabs.overview": "Geral",
  "liveDetails.tabs.schedules": "Agendamentos",
  "liveDetails.tabs.emails": "E-mails",
  "liveDetails.tabs.service": "Serviço",
  "liveDetails.name": "Título da Transmissão",
  "liveDetails.privacy": "Privacidade",
  "liveDetails.privacyPublic": "Público",
  "liveDetails.privacyUnlisted": "Não listado",
  "liveDetails.privacyPrivate": "Privado",
  "liveDetails.privacyPublicHint": "Qualquer pessoa pode encontrar e assistir a esta transmissão.",
  "liveDetails.privacyUnlistedHint": "Só quem tiver o link consegue assistir; não aparece em buscas.",
  "liveDetails.privacyPrivateHint": "Apenas pessoas autorizadas por você podem assistir.",
  "liveDetails.enableAudio": "Habilitar áudio",
  "liveDetails.backgroundMusic": "Música de fundo",
  "liveDetails.yes": "Sim",
  "liveDetails.no": "Não",
  "liveDetails.save": "Salvar",
  "liveDetails.saveConfig": "Salvar",
  "liveDetails.discardChanges": "Descartar alterações",
  "liveDetails.status": "Status",
  "liveDetails.playlist": "Playlist",
  "liveDetails.youtubeKeyId": "ID da chave do YouTube",
  "liveDetails.youtubeKey": "Chave do YouTube",
  "liveDetails.dropletId": "Droplet ID",
  "liveDetails.paid": "Pago",
  "liveDetails.device": "Local/Dispositivo",
  "liveDetails.paymentPreference": "Preferência de pagamento",
  "liveDetails.billedValue": "Valor cobrado",
  "liveDetails.paidLastStatus": "Último status do pagamento",
  "liveDetails.initiatedByEmail": "Iniciado por (email)",
  "liveDetails.initiatedByRole": "Iniciado por (perfil)",
  "liveDetails.schedulesTitle": "Agendamentos",
  "liveDetails.addSchedule": "Adicionar agendamento",
  "liveDetails.editSchedule": "Editar agendamento",
  "liveDetails.scheduleStartedDateLocked":
    "Essa transmissão já está em andamento — só é possível alterar a descrição.",
  "liveDetails.appendDescription": "Descrição",
  "liveDetails.startAt": "Início",
  "liveDetails.endAt": "Fim",
  "liveDetails.cancel": "Cancelar",
  "liveDetails.create": "Criar",
  "liveDetails.edit": "Editar",
  "liveDetails.delete": "Excluir",
  "liveDetails.deleteScheduleTitle": "Excluir agendamento",
  "liveDetails.deleteScheduleMessage": "Tem certeza que deseja excluir este agendamento de transmissão? Essa ação não pode ser desfeita.",
  "liveDetails.deleteScheduleMessageStarted":
    "Esta transmissão já está ao vivo. Excluir esse agendamento cancela a transmissão no YouTube agora mesmo. Essa ação não pode ser desfeita.",
  "liveDetails.deleteLive": "Excluir live",
  "liveDetails.deleteLiveTitle": "Excluir live",
  "liveDetails.deleteLiveMessage": "Tem certeza que deseja excluir esta live e todos os seus agendamentos? Essa ação não pode ser desfeita.",
  "liveDetails.noSchedules": "Nenhum agendamento encontrado.",
  "liveDetails.scheduleStatus": "Status",
  "liveDetails.emailsTitle": "E-mails",
  "liveDetails.email": "E-mail",
  "liveDetails.add": "Adicionar",
  "liveDetails.remove": "Excluir",
  "liveDetails.noEmails": "Nenhum e-mail cadastrado.",
  "liveDetails.serviceTitle": "Serviço",
  "liveDetails.toggleDroplet": "Iniciar/Parar serviço",
  "liveDetails.restartService": "Reiniciar serviço",
  "liveDetails.viewLogs": "Ver logs",
  "liveDetails.logsTitle": "Logs",
  "liveDetails.close": "Fechar",
  "liveDetails.adminOnlyService":
    "Somente administradores podem iniciar/reiniciar o serviço e ver logs.",

  "liveService.title": "Iniciar transmissão",
  "liveService.startStream": "Iniciar transmissão",
  "liveService.stopStream": "Finalizar transmissão",
  "liveService.autoLogs": "Atualizar logs",
  "liveService.autoLogsHint": "atualizando…",
  "liveService.logsPlaceholder": "Sem logs ainda.",
  "liveService.logsNotAvailable":
    "Logs indisponíveis para este serviço (droplet não encontrado).",
  "liveService.starting": "Iniciando transmissão…",
  "liveService.stopping": "Finalizando transmissão…",
  "liveService.restarting": "Reiniciando serviço…",
  "liveService.refreshFailed": "Ação aplicada, mas não foi possível atualizar o status na tela. Atualize a página.",
  "liveService.brandingSavedRestartFailed": "Configurações salvas, mas não foi possível reiniciar a transmissão para aplicar agora. Reinicie manualmente se necessário.",
  "liveService.notStarted":
    "Serviço não iniciou. Verifique o backend (droplet/logs).",
  "liveService.finishedHint":
    "Transmissão finalizada. Para iniciar novamente, crie uma nova transmissão.",

  // Live Scoreboard
  "liveScoreboard.pageTitle": "Placar da transmissão",
  "liveScoreboard.pageSubtitle": "Frontend do placar para operação da live.",
  "liveScoreboard.liveFallback": "Placar da transmissão",
  "liveScoreboard.liveFallbackWithId": "Transmissão #{id}",
  "liveScoreboard.simpleFlowHint":
    "Configuração do placar sincronizada com a transmissão.",
  "liveScoreboard.saveSuccess": "Configuração do placar salva.",
  "liveScoreboard.saveWarning":
    "Não foi possível salvar no backend agora. Preferência aplicada localmente.",
  "liveScoreboard.emptyNamesError": "Preencha os nomes do placar antes de salvar.",
  "liveScoreboard.saveBeforeGenerateLinkWarning":
    "Não foi possível salvar a configuração do placar antes de gerar o link do administrador.",
  "liveScoreboard.logoFallback": "Logo",
  "liveScoreboard.overlayName": "Placar",
  "liveScoreboard.defaultLogoName": "Meu Lance",
  "liveScoreboard.overlay.teamA": "• EQUIPE A",
  "liveScoreboard.overlay.teamB": "EQUIPE B",
  "liveScoreboard.overlay.pointHeader": "PONTOS",
  "liveScoreboard.overlay.primaryHeader": "GAMES",
  "liveScoreboard.overlay.scoreHeader": "SCORE",
  "liveScoreboard.overlay.pointShort": "PT",
  "liveScoreboard.overlay.setShort": "SETS",
  "liveScoreboard.configTag": "AGENDAMENTO / CONFIGURAÇÃO",
  "liveScoreboard.configTitle": "Ativar placar na transmissão",
  "liveScoreboard.configDescription":
    "Na criação da live, o dono do clube escolhe o esporte. Depois disso, o sistema gera automaticamente o link de administrador para operar o placar ao vivo.",
  "liveScoreboard.broadcastLabel": "Placar na transmissão",
  "liveScoreboard.enabled": "Ativado",
  "liveScoreboard.disabled": "Desativado",
  "liveScoreboard.toggleLabel": "Incluir placar na visão da câmera",
  "liveScoreboard.musicToggleLabel": "Incluir música de fundo na transmissão",
  "liveScoreboard.savingHint": "Salvando preferência do placar...",
  "liveScoreboard.sportTypeLabel": "Esporte do placar",
  "liveScoreboard.sport.football": "Futebol",
  "liveScoreboard.sport.padel": "Padel",
  "liveScoreboard.sport.beachTennis": "Beach Tennis",
  "liveScoreboard.generateAdminLink": "Gerar link do administrador",
  "liveScoreboard.adminLinkLabel": "Link do administrador",
  "liveScoreboard.adminTag": "ADMINISTRADOR / {sport}",
  "liveScoreboard.adminPanelTitle": "Painel do placar",
  "liveScoreboard.adminFootballDescription":
    "O funcionário do clube abre o link e controla tudo apenas nos botões de mais e menos.",
  "liveScoreboard.adminPadelDescription":
    "Também funciona só com mais e menos. O sistema entende a progressão do ponto automaticamente.",
  "liveScoreboard.adminBeachDescription":
    "Mesmo comportamento do padel, mantendo a operação simples e rápida durante a transmissão.",
  "liveScoreboard.enableToEdit":
    "Ative o placar na transmissão para liberar edição.",
  "liveScoreboard.team1Upper": "TIME 1",
  "liveScoreboard.team2Upper": "TIME 2",
  "liveScoreboard.teamA": "Time A",
  "liveScoreboard.teamB": "Time B",
  "liveScoreboard.matchTime": "Tempo da partida",
  "liveScoreboard.liveNow": "Ao vivo",
  "liveScoreboard.matchTimeLive": "{time} ({status})",
  "liveScoreboard.pair1Upper": "DUPLA 1",
  "liveScoreboard.pair2Upper": "DUPLA 2",
  "liveScoreboard.games": "Games",
  "liveScoreboard.sets": "Sets",
  "liveScoreboard.currentPoint": "Ponto atual",
  "liveScoreboard.ruleHintPadel":
    "Exemplo da regra automática: se estiver em 15 e tocar em mais, avança para 30. Tocando de novo, vai para 40.",
  "liveScoreboard.youtubeTitle": "Tela no YouTube - {sport}",
  "liveScoreboard.setLabel": "SET {set}",
  "liveScoreboard.summaryLine":
    "Sets: {setsA} x {setsB} | Ponto: {pointA} x {pointB}",
  "liveScoreboard.adminLinkSaved": "Configurações do link do administrador salvas com sucesso.",
  "liveScoreboard.adminLinkWarning":
    "Este link será usado por terceiros sem acesso à plataforma. Compartilhe o link e o código de acesso apenas com quem vai operar o placar desta partida.",
  "liveScoreboard.adminAccessCodeLabel": "Código de acesso",
  "liveScoreboard.adminAccessCodeNotRecoverable":
    "O código não pode ser exibido novamente. Gere um novo link para definir outro código.",
  "liveScoreboard.adminAccessCodeHelp":
    "Até 8 caracteres (letras e números). Se deixar em branco, será gerado automaticamente.",
  "liveScoreboard.generateRandomCode": "Gerar código aleatório",
  "liveScoreboard.adminLinkModalTitle": "Configurar link do administrador",
  "liveScoreboard.saveAdminLinkConfig": "Salvar configurações do link do administrador",
  "liveScoreboard.adminLinkExpirationLabel": "Expiração do link",
  "liveScoreboard.adminLinkExpirationFallback": "Expira 5 minutos após o fim da transmissão.",
  "liveScoreboard.adminLinkExpirationValue": "Expiração do link: {dateTime}",
  "liveScoreboard.public.accessCodeLabel": "Código de acesso",
  "liveScoreboard.public.accessCodeHelp": "Digite o código de acesso recebido com o link.",
  "liveScoreboard.public.unlock": "Acessar placar",
  "liveScoreboard.public.operatorTag": "OPERADOR DO PLACAR",
  "liveScoreboard.public.liveFallback": "Placar da transmissão",
  "liveScoreboard.public.invalidLink": "Link inválido. Verifique o código de acesso.",
  "liveScoreboard.public.disabledForLive": "Placar desativado para esta transmissão.",
  "liveScoreboard.public.expired":
    "Esta transmissão já encerrou. Este link expirou e o acesso público ao placar encerra 5 minutos após o fim da transmissão.",
  "liveScoreboard.public.accessDenied":
    "Acesso negado. O placar está desativado ou o código é inválido.",
  "liveScoreboard.public.accessUnavailable":
    "Não foi possível acessar este placar com os dados informados.",
  "liveScoreboard.public.saveRetryable":
    "Não foi possível salvar agora. Tente novamente.",
  "liveScoreboard.public.notFound": "Link de operador não encontrado.",
  "liveScoreboard.public.loadError": "Não foi possível carregar este placar agora.",
  "liveScoreboard.public.expiredSave": "Link expirado. Não é mais possível atualizar este placar.",

  // Notifications
  "notifications.title": "Notificações",
  "notifications.noIssues": "Nenhum problema encontrado",
  "notifications.issueItem": "{establishment}: {device} — {reasons}",
  "notifications.reason.OFFLINE": "Câmera offline",
  "notifications.reason.SD_CARD_ERROR": "Cartão SD com erro",
  "notifications.reason.BUTTON_SHORT_CIRCUIT": "Botoeira em curto",

  // Metric Chart
  "metricChart.channel": "Câmera",
  "metricChart.total": "Total",
  "metricChart.grandTotal": "Total Geral",
  "metricChart.loadError": "Erro ao carregar métricas",
  "metricChart.errorState": "Não foi possível carregar as métricas agora. Tente novamente em instantes.",
  "metricChart.showAll": "Exibir todas (+{count})",
  "metricChart.showLess": "Exibir menos",
  "metricChart.noData": "Nenhum dado encontrado.",
  "metricChart.metricsOmitted":
    "{count} métricas omitidas. Melhore os filtros para visualizar dados específicos.",

  // Analytics Reporter (legado)
  "analyticsReporter.title": "Relatório de Analytics",
  "analyticsReporter.startDate": "Data Inicial",
  "analyticsReporter.endDate": "Data Final",
  "analyticsReporter.search": "Buscar estabelecimento",
  "analyticsReporter.eventType": "Tipo de Evento",
  "analyticsReporter.generate": "Gerar Relatório",
  "analyticsReporter.total": "Total",
  "analyticsReporter.establishment": "Estabelecimento",
  "analyticsReporter.action": "Ação",
  "analyticsReporter.count": "Qtd",
  "analyticsReporter.errorMaxDays": "O intervalo de datas não pode exceder {maxDays} dias.",
  "analyticsReporter.loading": "Carregando...",
  "analyticsReporter.noData": "Nenhum dado encontrado.",
  "analyticsReporter.generating": "Gerando relatório...",
  "analyticsReporter.errorFetch": "Erro ao buscar relatório.",

  // Analytics V2
  "analyticsV2.title": "Relatórios",
  "analyticsV2.startDate": "Data Inicial",
  "analyticsV2.endDate": "Data Final",
  "analyticsV2.metric": "Métrica",
  "analyticsV2.format": "Formato",
  "analyticsV2.table": "Tabela",
  "analyticsV2.chart": "Gráfico",
  "analyticsV2.granularity": "Granularidade",
  "analyticsV2.daily": "Diário",
  "analyticsV2.monthly": "Mensal",
  "analyticsV2.total": "Total",
  "analyticsV2.groupBy": "Agrupar por:",
  "analyticsV2.court": "Quadra",
  "analyticsV2.all": "Todos",
  "analyticsV2.generateReport": "Gerar Relatório",
  "analyticsV2.totalEvents": "Total de eventos: {total}",
  "analyticsV2.chartNotAvailable":
    "Gráfico não disponível para granularidade Total. Use formato Tabela.",
  "analyticsV2.establishment": "Estabelecimento",
  "analyticsV2.event": "Evento",
  "analyticsV2.quantity": "Quantidade",
  "analyticsV2.date": "Data",
  "analyticsV2.noDataFound": "Nenhum dado encontrado.",
  "analyticsV2.selectMetric": "Selecione uma métrica",
  "analyticsV2.selectEstablishment": "Selecione pelo menos um estabelecimento",
  "analyticsV2.reportError": "Erro ao gerar relatório",
  "analyticsV2.download": "Baixar CSV",
  "analyticsV2.downloadError": "Erro ao baixar relatório",
  "analyticsV2.reportTitle": "Relatório - {metric}",
  "analyticsV2.period": "Período: {start} ~ {end}",
  "analyticsV2.channel": "Canal",
  "analyticsV2.description": "Descrição",

  // Metrics
  "metrics.custom_downloaded_video_2": "Download de Vídeo",
  "metrics.custom_played_video_2": "Visualização de Vídeo",
  "metrics.video_statistics": "Estatísticas de Vídeo",
  "metrics.custom_whatsapp_opening": "Abertura do WhatsApp",
  "metrics.scroll": "Rolagem",
  "metrics.custom_played_live": "Visualização de Live",
  "metrics.custom_sponsor_banner": "Banner do Patrocinador",
  "metrics.custom_prospectpro_banner": "Banner do patrocinador",
  "metrics.custom_prospectpro_popup": "Popup do patrocinador",
  "metrics.custom_deixacomochef_banner": "Banner do Deixa Com o Chef",
  "metrics.custom_deixacomochef_popup": "Popup do Deixa Com o Chef",
  "metrics.page_view": "Visualização de Página",
  "metrics.custom_instagram_opening": "Abertura do Instagram",
  "metrics.click": "Clique",
  "metrics.session_start": "Início de Sessão",
  "metrics.first_visit": "Primeira Visita",
  "metrics.user_engagement": "Engajamento do Usuário",
  "metrics.file_download": "Download de Arquivo",

  // Subscriptions Dashboard
  "subscriptions.title": "Assinaturas",
  "subscriptions.activeSubscriptions": "Assinaturas Ativas",
  "subscriptions.cancelledSubscriptions": "Assinaturas Canceladas",
  "subscriptions.expiredSubscriptions": "Assinaturas Expiradas",
  "subscriptions.singlePurchases": "Compras Avulsas",
  "subscriptions.subscriptionRevenueCollected": "Receita Recebida (Assinaturas)",
  "subscriptions.subscriptionRevenueTrial": "Em Trial (projetada, não recebida)",
  "subscriptions.singleRevenue": "Receita Compras Avulsas",
  "subscriptions.totalRevenue": "Receita Total Recebida",
  "subscriptions.noRecords": "Nenhum registro encontrado.",
  "subscriptions.searchPlaceholder": "Buscar por nome ou e-mail...",
  "subscriptions.filterType": "Tipo",
  "subscriptions.filterStatus": "Status",
  "subscriptions.filterOffering": "Produto",
  "subscriptions.filterStartDate": "Data Início",
  "subscriptions.filterEndDate": "Data Fim",
  "subscriptions.columnName": "Nome",
  "subscriptions.columnEmail": "E-mail",
  "subscriptions.columnType": "Tipo",
  "subscriptions.columnOffering": "Produto",
  "subscriptions.columnAmount": "Valor",
  "subscriptions.columnStatus": "Status",
  "subscriptions.columnDate": "Data",
  "subscriptions.columnNextBilling": "Próx. Cobrança",
  "subscriptions.columnCancellation": "Data Cancel.",
  "subscriptions.columnGatewayId": "Gateway ID",
  "subscriptions.rowsPerPage": "Linhas por página",
  "subscriptions.metricsExcludeTestNote": "Os números abaixo não incluem assinaturas marcadas como teste. Valores \"em trial\" ainda não foram cobrados.",
  "subscriptions.metricsCounts": "Contagens",
  "subscriptions.metricsRevenue": "Receita",
  "subscriptions.filterIncludeTest": "Mostrar testes",
  "subscriptions.hiddenTestCount": "{count} assinatura(s) de teste oculta(s) dos números e da lista.",
  "subscriptions.filterBillingPhase": "Fase",
  "subscriptions.billingPhase.trial": "Em trial",
  "subscriptions.billingPhase.active": "Cobrando",
  "subscriptions.testChip": "Teste",
  "subscriptions.trialChip": "Em trial",

  "subscriptionDetail.title": "Detalhes da Transação",
  "subscriptionDetail.visitorInfo": "Informações do Visitante",
  "subscriptionDetail.phone": "Telefone",
  "subscriptionDetail.transactionData": "Dados da Transação",
  "subscriptionDetail.type": "Tipo",
  "subscriptionDetail.product": "Produto",
  "subscriptionDetail.cycle": "Ciclo",
  "subscriptionDetail.value": "Valor",
  "subscriptionDetail.purchaseDate": "Data da Compra",
  "subscriptionDetail.nextBilling": "Próxima Cobrança",
  "subscriptionDetail.cancellation": "Cancelamento",
  "subscriptionDetail.technicalDetails": "Detalhes técnicos",
  "subscriptionDetail.internalTransactionId": "ID da Transação (interno)",
  "subscriptionDetail.externalId": "ID Externo (MP)",
  "subscriptionDetail.gatewayPaymentId": "Gateway Payment ID",
  "subscriptionDetail.subscriptionExternalId": "Subscription External ID",
  "subscriptionDetail.historyTitle": "Histórico de Transações do Visitante",
  "subscriptionDetail.noDataFound": "Nenhum dado encontrado para esta transação.",
  "subscriptionDetail.type.subscription": "Assinatura",
  "subscriptionDetail.type.singlePurchase": "Avulsa",
  "subscriptionDetail.cycle.monthly": "Mensal",
  "subscriptionDetail.cycle.annual": "Anual",
  "subscriptionDetail.status.approved": "Aprovado",
  "subscriptionDetail.status.pending": "Pendente",
  "subscriptionDetail.status.rejected": "Rejeitado",
  "subscriptionDetail.status.cancelled": "Cancelado",
  "subscriptionDetail.status.superseded": "Substituído",
  "subscriptionDetail.testChip": "Assinatura de teste",
  "subscriptionDetail.trialChip": "Em período de trial",
  "subscriptionDetail.markAsTest": "Marcar como teste",
  "subscriptionDetail.unmarkAsTest": "Remover marcação de teste",
  "subscriptionDetail.testMarkedBy": "Marcado como teste por {name} em {date}",
  "subscriptionDetail.testFlagUpdateSuccess": "Marcação de teste atualizada.",
  "subscriptionDetail.testFlagUpdateError": "Não foi possível atualizar a marcação de teste.",
  "auditLogs.title": "Auditoria",
  "auditLogs.tabActivities": "Atividades",
  "auditLogs.tabRequests": "Requisições",
  "auditLogs.when": "Quando",
  "auditLogs.who": "Quem",
  "auditLogs.what": "O que fez",
  "auditLogs.entity": "Entidade",
  "auditLogs.entityId": "ID",
  "auditLogs.method": "Método",
  "auditLogs.route": "Rota",
  "auditLogs.statusCode": "Status",
  "auditLogs.duration": "Duração",
  "auditLogs.filterUser": "Quem",
  "auditLogs.filterCategory": "Categoria",
  "auditLogs.filterAction": "Ação",
  "auditLogs.filterDateFrom": "De",
  "auditLogs.filterDateTo": "Até",
  "auditLogs.filterButton": "Filtrar",
  "auditLogs.placeholderEmail": "E-mail do usuário",
  "auditLogs.empty": "Nenhum registro encontrado",
  "auditLogs.selectCategoryFirst": "Selecione uma categoria primeiro",
  "auditLogs.allActions": "Todas as ações",
  "auditLogs.sessionExpired": "Sessão expirada. Faça login novamente.",
  "logoModels.title": "Meus modelos",
  "logoModels.subtitle": "Modelos de logos salvos para este estabelecimento",
  "logoModels.empty": "Nenhum modelo salvo ainda",
  "logoModels.noEstablishment": "Estabelecimento não identificado nesta transmissão",
  "logoModels.saveAsModel": "Salvar como modelo",
  "logoModels.saveAsModelTitle": "Salvar como modelo",
  "logoModels.nameLabel": "Nome do modelo",
  "logoModels.nameRequired": "Informe um nome",
  "logoModels.logosRequired": "Adicione pelo menos uma logo antes de salvar como modelo",
  "logoModels.created": "Modelo criado",
  "logoModels.updated": "Modelo atualizado",
  "logoModels.deleted": "Modelo excluído",
  "logoModels.createTitle": "Novo modelo",
  "logoModels.renameTitle": "Renomear modelo",
  "logoModels.createHint": "O modelo será criado com as logos configuradas nesta transmissão.",
  "logoModels.apply": "Aplicar",
  "logoModels.rename": "Renomear",
  "logoModels.delete": "Excluir",
  "logoModels.deleteTitle": "Excluir modelo?",
  "logoModels.deleteConfirm": "Tem certeza que deseja excluir o modelo \"{name}\"? As logos na transmissão não serão alteradas.",
  "logoModels.applied": "Modelo aplicado",
  "logoModels.logoCount": "{count, plural, one {# logo} other {# logos}}",
  "logoModels.newModel": "Novo modelo",
  "logoModels.suggestTitle": "Reutilizar logos",
  "logoModels.suggestBody": "O último modelo usado nesta quadra foi \"{name}\". Deseja reutilizá-lo?",
  "logoModels.suggestReuse": "Reutilizar",
  "logoModels.suggestChooseOther": "Escolher outro",
  "logoModels.suggestSetupManually": "Configurar manualmente",
};
